import { gQuery } from "../lib/graphql";
import { fetchCategoriesQuery } from "./gql";

export function useCategories() {
    return gQuery(fetchCategoriesQuery, { variables: {} });
}